import { useState } from 'react';
import { BrandMark } from './BrandMark';
import './ProductHeader.css';

/** Canonical Los Recomendados ecosystem header, locally vendored for the public Directory build. */
export function ProductHeader() {
  const [language, setLanguage] = useState<'es' | 'en'>('es');
  const isSpanish = language === 'es';

  return (
    <header className="lr-product-header">
      <div className="lr-product-header__inner">
        <a className="lr-product-header__brand" href="https://losrecomendados.co/" aria-label="LosRecomendados.co">
          <BrandMark className="lr-product-header__mark" size={31} />
          <span>LosRecomendados.co</span>
        </a>
        <div className="lr-product-header__actions">
          <a className="lr-product-header__link" href="https://app.losrecomendados.co/">
            {isSpanish ? 'Directorio' : 'Directory'} <span aria-hidden="true">↗</span>
          </a>
          <a className="lr-product-header__link" href="https://losrecomendados.co/hub/">
            {isSpanish ? 'Mi Hub' : 'My Hub'} <span aria-hidden="true">↗</span>
          </a>
          <button
            className="lr-product-header__language"
            type="button"
            onClick={() => setLanguage(isSpanish ? 'en' : 'es')}
            aria-label={isSpanish ? 'Switch to English' : 'Cambiar a español'}
          >
            {isSpanish ? 'EN' : 'ES'}
          </button>
        </div>
      </div>
    </header>
  );
}
